 /*
    var countMap = new Map();
    $(document).ready(function() {
        $(".page-dragImageBlock #tab-1").trigger('click');

        var before = "before";
        var after = "after";
        var dragImageProductBlockClassName = 'dragImageProductBlock';

        for (var i = 1;i <= {{ typeArray.size }};i++){
            var parentId = 'typeLineDiv-'+i;
            var count = $('#typeLineDiv-' + i).children('.dragImageProductBlock').length;
            countMap.set(i,count);
            if ( count > 4 ){
                // 复制前四个到最后
                var copyDiv1 = copyDivByParentIdDragImageBlock(0,"dragImageProductBlock-"+ i + '-' + (parseInt(count) + 1),(parseInt(count) + 1),dragImageProductBlockClassName,parentId,i);

                var copyDiv2 = copyDivByParentIdDragImageBlock(1,"dragImageProductBlock-"+ i + '-' + (parseInt(count) + 2),(parseInt(count) + 2),dragImageProductBlockClassName,parentId,i);

                var copyDiv3 = copyDivByParentIdDragImageBlock(2,"dragImageProductBlock-"+ i + '-' + (parseInt(count) + 3),(parseInt(count) + 3),dragImageProductBlockClassName,parentId,i);

                var copyDiv4 = copyDivByParentIdDragImageBlock(3,"dragImageProductBlock-"+ i + '-' + (parseInt(count) + 4),(parseInt(count) + 4),dragImageProductBlockClassName,parentId,i);


                // 复制最后四个到最前
                var copyDiv6 = copyDivByParentIdDragImageBlock(count-1,"dragImageProductBlock-"+ i + '-' + 0,0,dragImageProductBlockClassName,parentId,i);

                var copyDiv7 = copyDivByParentIdDragImageBlock(count-2,"dragImageProductBlock-"+ i + '-' + -1,-1,dragImageProductBlockClassName,parentId,i);

                var copyDiv8 = copyDivByParentIdDragImageBlock(count-3,"dragImageProductBlock-"+ i + '-' + -2,-2,dragImageProductBlockClassName,parentId,i);

                var copyDiv9 = copyDivByParentIdDragImageBlock(count-4,"dragImageProductBlock-"+ i + '-' + -3,-3,dragImageProductBlockClassName,parentId,i);


                // 粘贴
                // 前
                appendDivById(before,parentId,copyDiv1);
                appendDivById(before,parentId,copyDiv2);
                appendDivById(before,parentId,copyDiv3);
                appendDivById(before,parentId,copyDiv4);
                // 后
                appendDivById(after,parentId,copyDiv6);
                appendDivById(after,parentId,copyDiv7);
                appendDivById(after,parentId,copyDiv8);
                appendDivById(after,parentId,copyDiv9);

                var width = $(".dragImageListDiv").outerWidth() * -1;
                $(".dragImageListMoveDiv").css('left',width);


                var dragImgWidth = $('.dragImageProductBlock').outerWidth(true);
                dragImgMoveDiv.css('left',4 * dragImgWidth * -1);

                dragImgWidth = $('.dragImageProductBlock').outerWidth(true);
                dragImgMoveDiv.css('left',4 * dragImgWidth * -1);
                $(".dragImageListDiv").css('width',4 * dragImgWidth);
            }

        }

        if (!getChildCountByClassName('activeTypeLineDiv','dragImageProductBlock',4)){
            $(".dragImageBlockArrow").css('visibility','hidden');
        }


    })

    // 产品链接
    var clickUrl;

    // 经过加购按钮
    var addBTnText;
    $(".page-dragImageBlock .dragImageBlockDiv .bottomCardListDiv .dragImageListDiv .dragImageListMoveDiv .typeLineDiv  .dragImageProductBlock .productAddCartDiv .addCartBtn").hover(function (){
        addBTnText = $(this).text();
        $(this).text('SELECT OPTIONS');
    },function (){
        $(this).text(addBTnText);
    })

    // ====================切换==============================
    function dragImageBlockTabClick(index){

        $(".dragImageBlockDiv .tab").removeClass('dragImageBlock-activeTab');
        $("#tab-" + index).addClass('dragImageBlock-activeTab');

        var tabLeft = $("#tab-" + index).offset().left;
        var tabWidth = $("#tab-" + index).outerWidth();

        $(".topTabLine").css('left','calc(' + tabLeft + 'px - 13.021vw)' );

        $(".topTabLine").css('width',tabWidth);

        // 切换底部
        var clickTypeName = $("#tab-" + index).data('typename');

        $(".typeLineDiv").removeClass('activeTypeLineDiv');
        $(".typeLineDiv").css('display','none');

        $('.typeLineDiv[data-typename='+clickTypeName+']').addClass('activeTypeLineDiv');
        $('.typeLineDiv[data-typename='+clickTypeName+']').css('display','flex');
        var i = $(".activeTypeLineDiv").children(".dragImageProductBlock").length;
        if (i > 4){
            var width = $(".dragImageListDiv").outerWidth() * -1;
            $(".dragImageListMoveDiv").css('left',width);
            currentDragImgIndex = 1;
            $(".dragImageBlockArrow").css('visibility','visible');
        }else {
            $(".dragImageBlockArrow").css('visibility','hidden');
            $(".dragImageListMoveDiv").css('left',0);
        }

    }
*/
    // ===============================鼠标经过==============================
    $(".productImgDiv").hover(function (){
        // var imgUrlHover = $(this).data('imgurlhover');
        // $(this).children('.dragProductImage').css('opacity',0);
        // $(this).children('.dragProductImage').next().css('opacity',1);
        // $(this).children('.dragProductImage').next().css('transform','scale(1.2)');
        $(this).children('.dragProductImage').css('transform','scale({{ section.settings.pictureHoverScale }})');
    },function () {
        // $(this).children('.dragProductImage').next().css('opacity',0);
        // $(this).children('.dragProductImage').css('opacity',1);
        // $(this).children('.dragProductImage').next().css('transform','scale(1)');
        $(this).children('.dragProductImage').css('transform','scale({{ section.settings.pictureScale }})');
    })

    // ===========================下拉框监听========================================
    $(".productVariants").change(function (){

        //console.log( $(this).attr('id'));
        var productId =  $(this).data('productid');
        var chooseProduct;
        var variantChooseProduct;
        var variantId = $(this).val();
        var typeIndex = $(this).data('typeindex');
        var index = $(this).data('index');
        //根据id获取产品信息
        $.ajax({
            type: 'get',
            url:  window.routes.root + '/products.json',
            data: {
                product_id: $(this).data('productid')
            },
            success:function (data){
                //  console.log($("#dragImageVariantId-"+typeIndex+'-'+index))
                for (let i = 0; i < data.products.length; i++) {
                    if (data.products[i].id == productId){
                        chooseProduct = data.products[i]
                    }
                }
                //
                //console.log(chooseProduct.variants[i].id)
                for (let i = 0; i < chooseProduct.variants.length; i++) {
                    if (chooseProduct.variants[i].id == variantId){
                        variantChooseProduct = chooseProduct.variants[i];
                    }
                }


                // 设置对应图片
                if (variantChooseProduct.featured_image != null && variantChooseProduct.featured_image != 'null'){
                    $("#dragProductImage-"+typeIndex+"-"+index).attr('src',variantChooseProduct.featured_image.src) ;
                }


                // 设置对应变体id
                $("#dragImageVariantId-"+typeIndex+'-'+index).val(variantChooseProduct.id);

                // 设置标题
                //$("#dragProductHeading-"+typeIndex+'-'+index).val(variantChooseProduct.title);


                // 设置价格
                var oldCountryRate = getCurrencyInfo(JSON.parse(sessionStorage.getItem('currencyRate')),'US')[2];
                var currentCountryRate = getCurrencyInfo(JSON.parse(sessionStorage.getItem('currencyRate')),sessionStorage.getItem('currentCountry'))[2];
                // 计算新币种价格
                var price = variantChooseProduct.price * oldCountryRate / currentCountryRate;
                var compare_at_price = variantChooseProduct.compare_at_price * oldCountryRate / currentCountryRate;
                var priceDifference = price - compare_at_price;

                var currentCountryInfo = getCurrencyInfo(JSON.parse(sessionStorage.getItem('currencyRate')),sessionStorage.getItem('currentCountry'))
                $("#preferentialPrice-"+typeIndex+'-'+index).html(currentCountryInfo[1] + price.toFixed(2) + ' ' + currentCountryInfo[0]);
                $("#originalPrice-"+typeIndex+'-'+index).html(currentCountryInfo[1] + compare_at_price.toFixed(2) + ' ' + currentCountryInfo[0]);
                $("#customPercentageReduction-"+typeIndex+'-'+index).html(currentCountryInfo[1] + priceDifference.toFixed(2))
            }
        })

    })







/*
    // ===================================移动=============================
    // 基础参数
    var dragImgMoveDiv = $('.dragImageListMoveDiv');
    var dragImgWidth = $('.dragImageProductBlock').outerWidth(true);
    var currentDragImgIndex = 1;
    var animateFlag = false;

    // 监听修改页面大小
    $(window).resize(function() {
        dragImgMoveDiv = $('.dragImageListMoveDiv');
        dragImgWidth = $('.dragImageProductBlock').outerWidth(true);
        currentDragImgIndex = 1;

        dragImgMoveDiv.css('left',4 * dragImgWidth * -1);
        $(".dragImageListDiv").css('width',4 * dragImgWidth);
    });

    function moveNext() {

        // 判断是否还在动画
        if (animateFlag){
            return;
        }
        animateFlag = true;

        var count = countMap.get($(".activeTypeLineDiv").data('index'));

        currentDragImgIndex++;

        dragImgMoveDiv.stop().animate({left:'-=' + dragImgWidth + 'px' }, 500, function() {

            if (currentDragImgIndex >= count + 1){
                currentDragImgIndex = 1;
                dragImgMoveDiv.css('left',4 * dragImgWidth * -1);
            }
            animateFlag = false;
        });

    }

    function movePrevious() {

        if (animateFlag){
            return;
        }
        animateFlag = true;

        currentDragImgIndex--;
        var count = countMap.get($(".activeTypeLineDiv").data('index'));

        dragImgMoveDiv.stop().animate({left:'+=' + dragImgWidth + 'px' }, 500, function() {

            if (currentDragImgIndex <= -3){
                currentDragImgIndex = parseInt(count) - 3;
                dragImgMoveDiv.css('left','calc(' + (currentDragImgIndex - 1) * dragImgWidth * -1 + 'px -  62.292vw)' );
            }
            animateFlag = false;
        });
    }
*/
    /*=================== 拖拽 =================== */
 /* var dragImgIsKeyDown = false;
    var moveX = 0;
    var currentX;
    var triggerMoveX;
    var triggerCurrentX;


    // 监听按下
    dragImgMoveDiv.on('touchstart mousedown',function (e) {
        var count = countMap.get($(".activeTypeLineDiv").data('index'));

        dragImgIsKeyDown = true;
        if (count > 4){
            if (e.type == 'mousedown'){
                currentX = e.clientX;
                triggerCurrentX = e.clientX;
            }else if (e.type == 'touchstart'){
                currentX = e.originalEvent.changedTouches[0].clientX;
                triggerCurrentX = e.originalEvent.changedTouches[0].clientX;
            }
        }

    });

    function clickImgHref(event,url){
        clickUrl = url;
        var count = countMap.get($(".activeTypeLineDiv").data('index'));

        if (count > 4){
            dragImgIsKeyDown = true;
            if (event.type == 'mousedown'){
                currentX = event.clientX;
                triggerCurrentX = event.clientX;

            }else if (event.type == 'touchstart'){
                currentX = e.originalEvent.changedTouches[0].clientX;
                triggerCurrentX = e.originalEvent.changedTouches[0].clientX;

            }
        }
    }

    // 监听鼠标移动事件
    dragImgMoveDiv.on('touchmove mousemove',function (e) {
        var count = countMap.get($(".activeTypeLineDiv").data('index'));

        if (count > 4){
            if (dragImgIsKeyDown) {
                // 计算移动距离
                if (e.type == 'mousemove'){
                    moveX = parseInt(e.clientX) -  parseInt(currentX);
                    triggerMoveX =  parseInt(e.clientX) -  parseInt(triggerCurrentX);
                    // 重要！ 准确记录每次触发的移动量
                    triggerCurrentX = e.clientX;
                }else if (e.type == 'touchmove'){
                    moveX = parseInt(e.originalEvent.changedTouches[0].clientX) - parseInt(currentX);
                    triggerMoveX = parseInt(e.originalEvent.changedTouches[0].clientX) - parseInt(triggerCurrentX);
                    // 重要！ 准确记录每次触发的移动量
                    triggerCurrentX = e.originalEvent.changedTouches[0].clientX;
                }
                if (moveX == 0 || triggerMoveX == 0) {
                    return;
                }

                if (moveX > 0){
                    dragImgMoveDiv.stop().animate({left: "+=" + triggerMoveX * 1.15  + "px"}, 0, function() {

                    });
                }else if(moveX < 0){
                    dragImgMoveDiv.stop().animate({left: "+=" + triggerMoveX * 1.15 + "px"}, 0, function() {

                    });
                }

            }
        }


    })

    // 监听抬起
    dragImgMoveDiv.on('touchend mouseup',function (e) {

        var count = countMap.get($(".activeTypeLineDiv").data('index'));


        if (count > 4 && dragImgIsKeyDown){

            dragImgIsKeyDown = false;

            if (moveX == 0 && clickUrl != null && clickUrl.toString() != 'undefined') {
                window.location.href = clickUrl;
                return;
            }

            var maxLeft =($('.activeTypeLineDiv').children('.dragImageProductBlock').length - 4) * dragImgWidth;
            moveX = moveX * 1.15;


            // 超出的距离（余数）
            var moveCount =Math.round(Math.abs(parseInt(moveX)) / parseInt(dragImgWidth));
            var overX =Math.abs(parseInt(moveX)) % parseInt(dragImgWidth);
            var currentLeft = dragImgMoveDiv.css('left');
            var count = countMap.get($(".activeTypeLineDiv").data('index'));
            if (overX > (dragImgWidth / 2)){

                // 计算差值
                var move =  parseInt(dragImgWidth) - overX;

                if ((parseInt(currentLeft) + moveX + overX ) * -1 > maxLeft){
                    var last = (count * dragImgWidth * -1) + ( $(".dragImageListDiv").outerWidth() * -1);
                    dragImgMoveDiv.stop().animate({left: last + 'px' }, 300, function() {
                        animateFlag = false;
                    });
                }else if ((parseInt(currentLeft) + (moveCount * dragImgWidth) ) > 0){
                    dragImgMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
                        animateFlag = false;
                    });
                }else {

                    if (moveX > 0){
                        dragImgMoveDiv.stop().animate({left: (currentDragImgIndex - moveCount  + 3) * dragImgWidth * -1 + 'px' }, 300, function() {
                            animateFlag = false;
                        });
                    }else {
                        dragImgMoveDiv.stop().animate({left: (currentDragImgIndex + moveCount + 3 ) * dragImgWidth * -1 + 'px' }, 300, function() {
                            animateFlag = false;
                        });
                    }

                }

            }else{
                // 反之
                if ((parseInt(currentLeft) + moveX ) * -1 > maxLeft){

                    var last = (count * dragImgWidth * -1) + ( $(".dragImageListDiv").outerWidth() * -1);
                    dragImgMoveDiv.stop().animate({left: last + 'px' }, 300, function() {
                        animateFlag = false;
                    });
                }else if ((parseInt(currentLeft) + (moveCount * dragImgWidth) ) > 0){
                    dragImgMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
                        animateFlag = false;
                    });
                }else{
                    if (moveX > 0){
                        dragImgMoveDiv.stop().animate({left: (currentDragImgIndex - moveCount  + 3) * dragImgWidth * -1 + 'px' }, 300, function() {
                            animateFlag = false;
                        });

                    }else{
                        dragImgMoveDiv.stop().animate({left: (currentDragImgIndex + moveCount + 3 ) * dragImgWidth * -1 + 'px' }, 300, function() {
                            animateFlag = false;

                        });
                    }
                }

            }
            // 重置位移数，防止连点移动
            moveX = 0;

            sleep(350).then(() => {

                currentDragImgIndex = Math.floor(parseInt(dragImgMoveDiv.css('left')) * -1 / parseInt(dragImgWidth)) - 3;

                var count = countMap.get($(".activeTypeLineDiv").data('index'));

                if (currentDragImgIndex <= -3){
                    currentDragImgIndex = parseInt(count) - 3;
                    dragImgMoveDiv.css('left','calc(' + (currentDragImgIndex - 1) * dragImgWidth * -1 + 'px -  62.292vw)' );
                }

                if (currentDragImgIndex >= count + 1){
                    currentDragImgIndex = 1;
                    dragImgMoveDiv.css('left',4 * dragImgWidth * -1);
                }

            })


        }
        else if (count <= 4 && dragImgIsKeyDown) {
            if (moveX == 0 && clickUrl != null && clickUrl.toString() != 'undefined') {
                window.location.href = clickUrl;
            }
        }

    });

    $(".dragImageListDiv").hover(function (){

    },function (){
        var count = countMap.get($(".activeTypeLineDiv").data('index'));
        if (count > 4 && dragImgIsKeyDown){

            dragImgIsKeyDown = false;
            if (moveX == 0) {
                return;
            }
            var maxLeft =($('.activeTypeLineDiv').children('.dragImageProductBlock').length - 5) * dragImgWidth;
            moveX = moveX * 1.15;


            // 超出的距离（余数）
            var overX = Math.abs(moveX) % dragImgWidth;
            var currentLeft = dragImgMoveDiv.css('left');
            var count = countMap.get($(".activeTypeLineDiv").data('index'));
            var moveCount =Math.round(Math.abs(parseInt(moveX)) / parseInt(dragImgWidth));
            if (overX > (dragImgWidth / 2)){
                // 计算差值

                var move =  dragImgWidth - overX;

                if ((parseInt(currentLeft) + moveX + overX ) * -1 > maxLeft){

                    var last = (count * dragImgWidth * -1) + ( $(".dragImageListDiv").outerWidth() * -1);
                    dragImgMoveDiv.stop().animate({left: last + 'px' }, 300, function() {
                        animateFlag = false;
                    });
                }else if ((parseInt(currentLeft) + (moveCount * dragImgWidth)) > 0){

                    dragImgMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
                        animateFlag = false;
                    });
                }else {
                    if (moveX > 0){
                        dragImgMoveDiv.stop().animate({left: (currentDragImgIndex - moveCount  + 3) * dragImgWidth * -1 + 'px' }, 300, function() {
                            animateFlag = false;
                        });
                    }else {
                        dragImgMoveDiv.stop().animate({left: (currentDragImgIndex + moveCount + 3 ) * dragImgWidth * -1 + 'px' }, 300, function() {
                            animateFlag = false;
                        });
                    }

                }

            }else {
                // 反之
                if ((parseInt(currentLeft) + moveX ) * -1 > maxLeft){
                    var last = (count * dragImgWidth * -1) + ( $(".dragImageListDiv").outerWidth() * -1);
                    dragImgMoveDiv.stop().animate({left: last + 'px' }, 300, function() {
                        animateFlag = false;
                    });
                }else if ((parseInt(currentLeft) + (moveCount * dragImgWidth)) > 0){
                    dragImgMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
                        animateFlag = false;
                    });
                }else{
                    if (moveX > 0){
                        dragImgMoveDiv.stop().animate({left: (currentDragImgIndex - moveCount  + 3) * dragImgWidth * -1 + 'px' }, 300, function() {
                            animateFlag = false;
                        });
                    }else {
                        dragImgMoveDiv.stop().animate({left: (currentDragImgIndex + moveCount + 3 ) * dragImgWidth * -1 + 'px' }, 300, function() {
                            animateFlag = false;
                        });
                    }
                }

            }

            // 重置位移数，防止连点移动
            moveX = 0;

            sleep(350).then(() => {
                currentDragImgIndex = Math.floor(parseInt(dragImgMoveDiv.css('left')) * -1 / parseInt(dragImgWidth)) - 4;
                var count = countMap.get($(".activeTypeLineDiv").data('index'));

                if (currentDragImgIndex <= -4){
                    currentDragImgIndex = parseInt(count) - 4;
                    dragImgMoveDiv.css('left','calc(' + (currentDragImgIndex - 1) * dragImgWidth * -1 + 'px -  62.292vw)' );
                }

                if (currentDragImgIndex >= count+1){
                    currentDragImgIndex = 1;
                    dragImgMoveDiv.css('left',5 * dragImgWidth * -1);
                }

            })


        }
    })

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
*/
    /**
     * 判断子类元素是否多于期望数
     * @param parentClassName
     * @param childClassName
     * @param expectCount
     */
    function getChildCountByClassName(parentClassName,childClassName,expectCount){

        var count = $("."+parentClassName).children('.'+childClassName).length;

        if (count > expectCount){
            return true;
        }else {
            return false;
        }

    }


    var dragImageListPCMaxSwiper = new Swiper("#dragImageListSwiperDiv", {
        slidesPerView: 'auto',
        preventClicks:'false',
        spaceBetween: 64,
        touchRatio:1.5,
        loop:true,
    });

    function movePrevious() {
        dragImageListPCMaxSwiper.slidePrev();
    }

    function moveNext() {
        dragImageListPCMaxSwiper.slideNext();
    }
